<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer.drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    app
    width="260"
    v-bind="$attrs"
    v-if="showDrawer"
    class="drawer-scrollbar"
  >

    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list
      expand
      nav
    >

      <template v-for="(item, index) in filteredItems">
        <v-subheader
          v-if="item.header"
          :key="item.header"
          inset
        >
          {{ item.header }}
        </v-subheader>
        <v-divider
          v-else-if="item.divider"
          :key="index"
          class="divider-margin"
        />
        <v-list-item v-else
          :key="item.to"
          :to="item.to"
          class="v-list-item"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="item.title" />
        </v-list-item>
      </template>
      <center>V{{ currentVersion() }}</center>
      <center>{{ clientPrefix }}</center>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import canGoTo from '../../router/can-go-to'
import routerPermissions from '../../router/routerPermissions'
import LocalStorageService from '../../services/LocalStorageService'
import LoginService from '../../services/LoginService'

export default {
  name: 'Drawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showDrawer: true,
    clientPrefix: '',
    userDetails: {
      permissions: [],
      userKey: {
        username: '',
        clientPrefix: ''
      }
    }
  }),
  computed: {
    ...mapState(['barColor', 'barImage', 'drawer']),
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (val) {
        this.$store.commit('setDrawer', val)
      }
    },

    profile () {
      return {
        avatar: true,
        title: 'avatar'
      }
    },

    filteredItems () {
      const user = this.userDetails
      return this.items
        .filter(item => item.divider || routerPermissions.some(p => p.path === item.to))
        .filter(item => item.divider || canGoTo(item.to, user))
        .filter(this.noConsecutiveDivider)
    },

    items () {
      return [
        {
          title: this.$t('keywords.about'),
          to: '/',
          icon: 'mdi-earth'
        },
        {
          title: this.$t('keywords.newsletter'),
          to: '/newsletter',
          icon: 'mdi-new-box'
        },
        {
          divider: true
        },
        {
          title: this.$t('keywords.dashboard'),
          to: '/dashboard',
          icon: 'mdi-chart-bar'
        },
        {
          title: this.$t('keywords.monitoring'),
          to: this.$versionable.decorators.monitoring.path,
          icon: 'mdi-clipboard-pulse-outline'
        },
        {
          divider: true
        },
        {
          title: this.$t('keywords.api_query'),
          to: '/consulta-apis',
          icon: 'mdi-weather-cloudy-arrow-right'
        },
        {
          title: this.$t('keywords.send_data.rest'),
          to: '/job-envia-dados-rest',
          icon: 'mdi-code-json'
        },
        {
          title: this.$t('keywords.send_data.soap'),
          to: '/job-envia-dados-soap',
          icon: 'mdi-code-tags'
        },
        {
          title: this.$t('keywords.rest_to_soap'),
          to: '/rest-to-soap',
          icon: 'mdi-cloud-tags'
        },
        {
          title: this.$t('keywords.workflow'),
          to: '/workflow',
          icon: 'mdi-clipboard-flow-outline'
        },
        {
          divider: true
        },
        {
          title: this.$t('keywords.db_register'),
          to: '/cadastro-db',
          icon: 'mdi-database'
        },
        {
          title: this.$t('keywords.credentials'),
          to: '/credentials',
          icon: 'mdi-card-account-details-outline'
        },
        {
          title: this.$t('keywords.from_to'),
          to: '/from-to',
          icon: 'mdi-swap-horizontal'
        },
        {
          title: this.$t('keywords.params'),
          to: '/parameter',
          icon: 'mdi-download-multiple'
        },
        {
          title: this.$t('keywords.sequences'),
          to: '/sequence',
          icon: 'mdi-numeric'
        },
        /* {
          title: this.$t('keywords.server.socket'),
          to: '/socket-server',
          icon: 'mdi-connection'
        }, */
        {
          title: this.$t('keywords.server.email'),
          to: '/emailserver',
          icon: 'mdi-email-send'
        },
        {
          divider: true
        },
        {
          title: this.$t('keywords.clients'),
          to: '/client',
          icon: 'mdi-clipboard-account-outline'
        },
        {
          title: this.$t('keywords.users'),
          to: '/user',
          icon: 'mdi-account-supervisor-circle'
        },
        {
          divider: true
        },
        {
          title: this.$t('keywords.truststore'),
          to: '/truststore',
          icon: 'mdi-aws'
        },
        {
          divider: true
        }
      ]
    }

  },

  methods: {
    currentVersion () {
      return LocalStorageService.getCurrentVersion()
    },

    checkRoute (path) {
      const notEnterPath = !(path === '/login' || path === '/select-client')

      this.showDrawer = notEnterPath
      if (notEnterPath) {
        this.updateUserDetails()
        this.updateClientPrefix()
      }
    },

    updateUserDetails () {
      LoginService.getUserDetails()
        .then(response => { this.userDetails = response.data })
        .catch(error => console.error(error))
    },

    updateClientPrefix () {
      this.clientPrefix = LocalStorageService.getClientPrefix()
    },

    noConsecutiveDivider (value, index, list) {
      const previousValue = list[index - 1]

      return !(value.divider && previousValue?.divider)
    },

    ...mapMutations(['setDrawer'])
  },

  watch: {
    $route (newRoute) { this.checkRoute(newRoute.fullPath) }
  },

  mounted () {
    this.checkRoute(this.$router.currentRoute.fullPath)
  }
}
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px

    ::-webkit-scrollbar
      background-color: rgb(54, 54, 54)
      width: 10px

    ::-webkit-scrollbar-track
      background-color: rgb(54, 54, 54)

    ::-webkit-scrollbar-track:hover
      background-color: rgb(54, 54, 54)

    ::-webkit-scrollbar-thumb
      background-color: rgb(160, 160, 160)
      border-radius: 8px
      border: 2px solid rgb(54, 54, 54)

    ::-webkit-scrollbar-thumb:hover
      background-color: rgb(190, 190, 190)

    ::-webkit-scrollbar-button
      display: none
    .divider-margin
      margin-bottom: 8px
</style>
